<div role="tablist" class="nav nav-tabs">
	@for (tab of tabsToShow; track tab; let idx = $index) {
		<a
			role="tab"
			[attr.aria-selected]="isActiveTab(tab)"
			aria-controls="catalog-tab-panel"
			class="nav-link d-flex text-dark"
			[class.active]="isActiveTab(tab)"
			[routerLink]="getTabRouterLink(tab)"
			[queryParams]="getQueryParams(tab, idx)"
			queryParamsHandling="merge">
			@if (tab === ViewGroups.Protocol) {
				<div class="flag-image mask-settings grid-mask-img bg bg-primary flag-filled-mask-img"></div>
			}
			<div>
				{{ getTabKey(tab) | translate }}
				@if (tab === ViewGroups.Sustainability) {
					<img
						src="/assets/sustainability/nachhaltigkeit.svg"
						class="sustainability-image"
						alt="{{ getTabKey(tab) | translate }}"
						loading="eager" />
				}
			</div>
		</a>
	}
</div>
